import { atom } from 'jotai';
import { AppAuthState, AuthState, UnknownAppStage } from '../../types';

export const appAuthAtom = atom<AppAuthState>({
  isAuthenticated: false,
  authStatus: AuthState.Unknown,
  stage: UnknownAppStage.SSOLoading,
});
